import type { ComponentType } from 'react'
import { GlowCard } from './GlowCard'
import { Sparkline } from './Sparkline'
import { useCountUp } from '../../hooks/useCountUp'

interface StatCardProps {
  icon: ComponentType<{ size?: number; style?: React.CSSProperties }>
  label: string
  value: number
  prefix?: string
  suffix?: string
  trend?: 'up' | 'down'
  trendVal?: string
  spark?: number[]
  delay?: number
  onClick?: () => void
}

export function StatCard({ icon: Icon, label, value, prefix = '', suffix = '', trend, trendVal, spark, delay = 0, onClick }: StatCardProps) {
  const animated = useCountUp(value, 1000)
  const isUp = trend === 'up'

  return (
    <GlowCard delay={delay} onClick={onClick} style={{ flex: 1, minWidth: 0, padding: `calc(20px * var(--density))` }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
        <div style={{
          width: 36, height: 36, borderRadius: 'var(--r-m)', background: 'var(--accent-m)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon size={17} style={{ color: 'var(--accent)' }} />
        </div>
        {spark && <Sparkline data={spark} />}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 6 }}>
        <span style={{
          fontFamily: 'var(--mono)', fontSize: 28, fontWeight: 600, color: 'var(--text-1)',
          lineHeight: 1, letterSpacing: '-.02em',
        }}>
          {prefix}{animated.toLocaleString()}{suffix}
        </span>
        {trendVal && (
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 2, fontSize: 11, fontWeight: 600,
            fontFamily: 'var(--mono)', color: isUp ? 'var(--ok)' : 'var(--err)',
            background: isUp ? 'var(--ok-m)' : 'var(--err-m)', padding: '2px 7px', borderRadius: 'var(--r-f)',
            whiteSpace: 'nowrap', flexShrink: 0,
          }}>
            {isUp ? '\u2197' : '\u2198'}{trendVal}
          </span>
        )}
      </div>
      <div style={{ fontSize: 13, color: 'var(--text-2)', fontFamily: 'var(--font)', fontWeight: 400 }}>{label}</div>
    </GlowCard>
  )
}
